/* Lieferadresse nur bei Versand/Fahrer: sichtbar, Pflicht, gesendet (disabled fieldset = keine Validierung, kein Versand). */
(() => {
  const sync = () => {
    const wahl = document.getElementById('ak-anfrage-wunsch');
    const adresse = document.getElementById('ak-anfrage-adresse');
    if (!wahl || !adresse) return;
    const lieferung = wahl.value !== 'Abholung Lager Hagen';
    adresse.hidden = adresse.disabled = !lieferung;
    const tel = document.getElementById('ak-anfrage-telefon');
    if (tel) tel.required = lieferung;
    document.querySelectorAll('[data-anfrage-tel-opt]').forEach(e => { e.hidden = lieferung; });
    document.querySelectorAll('[data-anfrage-tel-pflicht]').forEach(e => { e.hidden = !lieferung; });
  };
  document.addEventListener('change', e => { if (e.target.id === 'ak-anfrage-wunsch') sync(); });
  // Chrome scrollt beim Fokus nicht, wenn ein Feld halb sichtbar ist; so kommt es samt scroll-margin unter Kopf und mobiler Leiste hervor (WCAG 2.4.11).
  document.addEventListener('focusin', e => { if (e.target.closest?.('#akkaya-anfrage')) e.target.scrollIntoView({ block: 'nearest' }); });
  sync();  // Browser stellt die Auswahl beim Zurueckgehen wieder her
})();

/* Keep server-rendered inquiry positions in sync with AJAX cart changes. */
(() => {
  const container = document.getElementById('akkaya-anfrage');
  const sectionId = container?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
  if (!sectionId) return;

  document.addEventListener('cart:grouped-sections', (event) => {
    if (!event.detail.sections.includes(sectionId)) event.detail.sections.push(sectionId);
    const button = container.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    const status = container.querySelector('[data-anfrage-status]');
    if (status) status.hidden = false;
  });

  document.addEventListener('cart:updated', (event) => {
    const markup = event.detail.cart.sections?.[sectionId];
    // On missing/failed section rendering keep submission blocked; reloading is safe.
    if (!markup) return;
    const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('#akkaya-anfrage');
    if (!fresh) return;
    // A mode change also changes the page heading and form; render that transition atomically.
    if (container.dataset.kauf !== fresh.dataset.kauf) {
      window.location.reload();
      return;
    }
    const currentForm = container.querySelector('form');
    const nextForm = fresh.querySelector('form');
    if (!currentForm || !nextForm) {
      container.innerHTML = fresh.innerHTML;
      return;
    }
    const names = ['contact[Positionen]', 'contact[Kurzform zum Kopieren]'];
    const pairs = names.map(name => [currentForm.elements.namedItem(name), nextForm.elements.namedItem(name)]);
    if (pairs.some(([current, next]) => !current || !next)) return;
    pairs.forEach(([current, next]) => { current.value = next.value; });
    currentForm.querySelector('[type="submit"]').disabled = false;
    const status = container.querySelector('[data-anfrage-status]');
    if (status) status.hidden = true;
  });
})();
